export default {
    upload: 'Upload file',
    orDragAndDrop: 'or drag and drop here'
}
